import { createAsyncThunk } from "@reduxjs/toolkit";
import PolicyImprovementsAPI, {
    PolicyImprovementListResponse,
    UpsertPolicyImprovementsRequest,
} from "../../../api/policyImprovements";
import { MessageResponse } from "../../../api/common";

export const fetchPolicyImprovementsThunk = createAsyncThunk<
    PolicyImprovementListResponse,
    { caseId: string },
    { rejectValue: string }
>(
    "policyImprovements/getAll",
    async ({ caseId }, { rejectWithValue }) => {
        try {
            return await PolicyImprovementsAPI.get(caseId);
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data?.message ||
                    error.message ||
                    "Failed to fetch policy improvements"
            );
        }
    },
    {
        condition({ caseId }, { getState }) {
            const s = (getState() as any).policyImprovementsData;
            if (s.status === "loading") return false;
            if (s.status === "succeeded" && s.caseId === caseId) return false;
            return true;
        },
    }
);

export const upsertPolicyImprovementsThunk = createAsyncThunk<
    MessageResponse,
    { caseId: string; request: UpsertPolicyImprovementsRequest },
    { rejectValue: string }
>(
    "policyImprovements/upsert",
    async ({ caseId, request }, { rejectWithValue }) => {
        try {
            return await PolicyImprovementsAPI.upsert(caseId, request);
        } catch (error: any) {
            return rejectWithValue(
                error.message || "Failed to save policy improvements"
            );
        }
    }
);

export const deletePolicyImprovementThunk = createAsyncThunk<
    MessageResponse,
    { caseId: string; policyId: string },
    { rejectValue: string }
>(
    "policyImprovements/delete",
    async ({ caseId, policyId }, { rejectWithValue }) => {
        try {
            return await PolicyImprovementsAPI.delete(caseId, policyId);
        } catch (error: any) {
            return rejectWithValue(
                error.message || "Failed to delete policy improvement"
            );
        }
    }
);